<template>
  <div class="container">
    <div class="row">
      <div class="page-body overlap">
        <h1 class="page-title">{{ title }}</h1>

        <div class="single-col"> 
          <div class="content-panel">
            <div class="panel-tabs">
              <ul>
                <li v-for="(product, productIndex) in productTabs" :key="productIndex" :class="[{ active: currentTab === product.ref }]">
                  <a href="javascript:;" @click="currentTab = product.ref" :title="product.name">{{ product.name }}</a>
                </li>
              </ul>
            </div>

            <flight-bookings :agencyUsers="agencyUsers" v-if="currentTab === 'flights' && agencyUsers" />
            <hotel-bookings :agencyUsers="agencyUsers" v-if="currentTab === 'hotels' && agencyUsers" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FlightBookings from "@/components/admin/FlightBookings";
import HotelBookings from "@/components/admin/HotelBookings";
import UsersApi from "@/services/admin/usersApi";

export default {
  name: 'Bookings',
  data () {
    return {
      title: 'Bookings',
      currentTab: 'flights',
      usersApi: new UsersApi(),
      agencyUsers: null,
      productTabs: [ 
        {
          ref: 'flights',
          name: 'Flights' 
        },
        {
          ref: 'hotels',
          name: 'Hotels' 
        }
      ]
    }
  },

  async created() {
    let self = this;
    let response = await self.usersApi.getUsers();
    self.agencyUsers = response.data;
  },

  metaInfo: {
    title: 'All Bookings',
  },

  components: {
    FlightBookings,
    HotelBookings
  }
}
</script>
